import axios from 'axios';
import Strings from '../../constants/stringConstant';
const DEFAULT_TIMEOUT = 300000;
const HTTP_GET = 'get';
const HTTP_POST = 'post';
const HTTP_DELETE = 'delete';
import makeApiCall from '../makeApiCall';
import { refreshApi } from '../request/loginApi/loginApi';
import { LOGOUT } from '../resources/endPoint';
import { toast } from 'react-toastify';
const baseURL = window.env.REACT_APP_API_URL;
// const baseURL = 'https://qa-los.iiflsamasta.com/api/';
const callRefreshTokenApi = async tokenVal => {
  const payload = {
    token: tokenVal,
    grant_type: 'refresh_token',
  };
  await makeApiCall(refreshApi(payload));
};
// const getBaseURL = microservice => {
//   let baseURL = null;

//   switch (microservice) {
//     case 'loan-data-service':
//       baseURL = 'https://dev-los.iiflsamasta.com/loan/';
//       break;
//     default:
//       baseURL = 'https://dev-los.iiflsamasta.com/';
//       break;
//   }

//   return baseURL;
// };

const UseAxios = async request => {
  const axiosConfig = {
    baseURL: baseURL,
    timeout: DEFAULT_TIMEOUT,
    headers: {
      'Content-Type': request.headers['content-type'],
      'Strict-Transport-Security':
        'max-age=31536000; includeSubDomains; preload',
      'Content-Security-Policy':
        "default-src 'self' blob:; script-src 'self' https://trusted-source.com; object-src 'self' blob:; frame-src 'self' blob:",
      'X-Frame-Options': 'DENY',
      'Permissions-Policy': 'geolocation=(), microphone=(), camera=()',
      'Referrer-Policy': 'no-referrer-when-downgrade',
    },
  };

  if (request.responseType) {
    axiosConfig.responseType = request.responseType;
  }

  const instance = axios.create(axiosConfig);

  let axiosRequest = null;
  const { method, url, payload, tag } = request;
  const token = sessionStorage.getItem(Strings?.login?.auth_token);
  const authRefreshToken = JSON.parse(token);
  const authRequired = request.authRequired;

  if (authRequired) {
    instance.defaults.headers.common.Authorization = `Bearer ${authRefreshToken.accessToken}`;
  } else if (request.tokenExpiry) {
    instance.defaults.headers.common.Authorization = `Bearer ${authRefreshToken.refreshToken}`;
  } else {
    delete instance.defaults.headers.common.Authorization;
  }

  if (method === HTTP_GET) {
    axiosRequest = instance.get(url);
  } else if (method === HTTP_POST) {
    axiosRequest = instance.post(url, payload);
  } else if (method === HTTP_DELETE) {
    axiosRequest = instance.delete(url, { data: payload });
  }
  if (axiosRequest === null) {
    throw new Error('Invalid request');
  }
  let intervalInstance = '';

  return axiosRequest
    .then(async response => {
      if (response?.data?.data?.accessToken) {
        intervalInstance = sessionStorage.getItem(
          Strings?.login?.interval_instance,
        );
        clearTimeout(intervalInstance);
        const tokens = {
          accessToken: response?.data?.data?.accessToken,
          refreshToken: response?.data?.data?.refreshToken,
        };
        const accessToken = response?.data?.data?.accessToken;
        const accessTokenExpiry =
          response?.data?.data?.accessTokenExpiry &&
          parseInt(response?.data?.data?.accessTokenExpiry);
        const TOKEN_EXP_TIME = accessTokenExpiry * 60 * 60 * 1000 - 3000;

        sessionStorage.setItem(
          Strings?.login?.auth_token,
          JSON.stringify(tokens),
        );
        intervalInstance = setTimeout(() => {
          callRefreshTokenApi(accessToken);
        }, TOKEN_EXP_TIME);
        sessionStorage.setItem(
          Strings?.login?.interval_instance,
          intervalInstance,
        );
      }
      if (request.tag === LOGOUT) {
        intervalInstance = sessionStorage.getItem(
          Strings?.login?.interval_instance,
        );
        clearTimeout(intervalInstance);
      }

      return { tag, data: response.data };
    })
    .catch(function (error) {
      let err = null;
      if (error?.response?.status === 401) {
        let msg = null;
        if (error.response.data) {
          msg = error.response.data;
          msg = msg.message;
        } else {
          msg = error.response.statusText;
        }
        err = {
          code: error.response.status,
          message: msg,
        };
        sessionStorage.removeItem('isLoggedIn');
        sessionStorage.removeItem('auth_token');
        window.location.href = '/';
      } else if (error?.response?.status === 429) {
        toast.error('Too Many Requests. Please try again after some time.');
      } else {
        err = {
          code: error?.response?.status,
          message: error?.response?.statusText,
        };
      }
      toast.error(error?.response?.data?.errorMessage);
      throw err;
    });
};

export default UseAxios;
